// Forum Category Filter
let categoryList = document.getElementById("category-list");
let categorySearchInput = document.getElementById("category-filter-search");
let closeCategoryFilter = document.getElementById("close-category-filter");
let categoryfilter = document.getElementById("category-filter");
let listOfCategories = [];

// Forum Merchant Filter
let merchantList = document.getElementById("merchant-list");
let searchInput = document.getElementById("filter-search");
let closeMerchantFilter = document.getElementById("close-merchant-filter");
let merchantfilter = document.getElementById("merchant-filter");
let listOfMerchants = [];

// Function to update filter count badges
function updateFilterCount(filterType, count) {
  const badges = document.querySelectorAll(`.filter-count[data-filter="${filterType}"]`);
  badges.forEach(badge => {
    if (count > 0) {
      badge.textContent = count;
      badge.classList.remove('hidden');
    } else {
      badge.classList.add('hidden');
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  if (!categoryfilter && !merchantfilter) return;

  // Get list of merchants
  getListofMerchants();

  async function getListofMerchants() {
    await fetch("/all_active_stores.json")
    .then((response) => response.json())
    .then((data) => {
      listOfMerchants = data;
    })
    .catch((error) => console.error("Error fetching merchants:", error));
  }

  // Filter button click handlers - using class selector since buttons don't have unique IDs
  document.querySelectorAll('.filter-opt').forEach(btn => {
    btn.addEventListener('click', function() {
      const cat = this.dataset.cat;

      if (window.innerWidth < 768) {
        document.body.classList.add("overflow-hidden");
      }

      if (cat === 'categories' && categoryfilter) {
        // Close merchant filter if open
        if (merchantfilter) {
          closeFilterPanel(merchantfilter);
        }

        openFilterPanel(categoryfilter, this);

        // Render all categories
        if (categoryList) {
          categoryList.innerHTML = "";
          const allCategoriesEl = document.getElementById('AllCategories');
          if (allCategoriesEl) {
            const categoriesData = JSON.parse(allCategoriesEl.getAttribute('data-all-categories'));
            listOfCategories = categoriesData;
            categoriesData.forEach(category => renderCategory(category, false));
          }
        }
      } else if (cat === 'structure' && merchantfilter) {
        // Close category filter if open
        if (categoryfilter) {
          closeFilterPanel(categoryfilter);
        }

        openFilterPanel(merchantfilter, this);

        // Clear and render merchants
        if (merchantList) {
          merchantList.innerHTML = "";
          listOfMerchants.forEach((merchant) => {
            renderMerchant(merchant, false);
          });
        }
      }
    });
  });

  // Category Filter Close
  if (closeCategoryFilter) {
    closeCategoryFilter.addEventListener("click", () => {
      if (window.innerWidth < 768) {
        document.body.classList.remove("overflow-hidden");
      }
      closeFilterPanel(categoryfilter);
    });
  }

  // Merchant Filter Close
  if (closeMerchantFilter) {
    closeMerchantFilter.addEventListener("click", () => {
      if (window.innerWidth < 768) {
        document.body.classList.remove("overflow-hidden");
      }
      closeFilterPanel(merchantfilter);
    });
  }

  // Category Search
  if (categorySearchInput) {
    categorySearchInput.addEventListener("input", function () {
      const searchTerm = this.value.trim();
      if (searchTerm.length >= 2) {
        const checkedCategories = Array.from(
          categoryList.querySelectorAll('input[type="checkbox"]:checked')
        ).map((checkbox) => ({
          id: checkbox.value,
          name: checkbox.dataset.categoryName,
        }));

        // Clear existing category list
        categoryList.innerHTML = "";

        // Render checked categories first
        checkedCategories.forEach((category) => {
          renderCategory(category, true);
        });

        // Filter and render matching categories
        const filteredCategories = listOfCategories.filter(cat =>
          cat.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

        if (filteredCategories.length === 0) {
          const noResultDiv = document.createElement("div");
          noResultDiv.textContent = `${document.getElementById("no-category-results-found").innerText} ${searchTerm}`;
          noResultDiv.style.paddingBottom = '10px';
          categoryList.prepend(noResultDiv);
        } else {
          filteredCategories.forEach((category) => {
            const isChecked = checkedCategories.some(
              (checkedCat) => checkedCat.id === category.id
            );
            if (!isChecked) {
              renderCategory(category, false);
            }
          });
        }
      } else if (searchTerm.length == 0) {
        const checkedCategories = Array.from(
          categoryList.querySelectorAll('input[type="checkbox"]:checked')
        ).map((checkbox) => ({
          id: checkbox.value,
          name: checkbox.dataset.categoryName,
        }));

        // Clear existing category list
        categoryList.innerHTML = "";

        // Render checked categories first
        checkedCategories.forEach((category) => {
          renderCategory(category, true);
        });

        // Render unchecked categories
        listOfCategories.forEach((category) => {
          const isChecked = checkedCategories.some(
            (checkedCat) => checkedCat.id === category.id
          );
          if (!isChecked) {
            renderCategory(category, false);
          }
        });
      }
    });
  }

  // Merchant Search
  if (searchInput) {
    searchInput.addEventListener("input", function () {
      const searchTerm = this.value.trim();
      if (searchTerm.length >= 2) {
        fetch(`/all_active_stores.json?term=${encodeURIComponent(searchTerm)}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            const checkedMerchants = Array.from(
              merchantList.querySelectorAll('input[type="checkbox"]:checked')
            ).map((checkbox) => ({
              permalink: checkbox.value,
              merchant_name: checkbox.dataset.merchantName,
            }));

            // Clear existing merchant list
            merchantList.innerHTML = "";

            // Render checked merchants first
            checkedMerchants.forEach((merchant) => {
              renderMerchant(merchant, true);
            });

            // Render unchecked merchants then
            if (data.length === 0) {
              const noResultDiv = document.createElement("div");
              noResultDiv.textContent = `${ document.getElementById("no-results-found").innerText } ${searchTerm}`;
              noResultDiv.style.paddingBottom = '10px';
              merchantList.prepend(noResultDiv);
            } else {
              data.forEach((merchant) => {
                const isChecked = checkedMerchants.some(
                  (checkedMerchant) =>
                    checkedMerchant.permalink === merchant.permalink
                );
                if (!isChecked) {
                  renderMerchant(merchant, false);
                }
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching merchants:", error);
          });
      } else if (searchTerm.length == 0) {
        const checkedMerchants = Array.from(
          merchantList.querySelectorAll('input[type="checkbox"]:checked')
        ).map((checkbox) => ({
          permalink: checkbox.value,
          merchant_name: checkbox.dataset.merchantName,
        }));

        // Clear existing merchant list
        merchantList.innerHTML = "";

        // Render checked merchants first
        checkedMerchants.forEach((merchant) => {
          renderMerchant(merchant, true);
        });

        // Render unchecked merchants
        listOfMerchants.forEach((merchant) => {
          const isChecked = checkedMerchants.some(
            (checkedMerchant) =>
              checkedMerchant.permalink === merchant.permalink
          );
          if (!isChecked) {
            renderMerchant(merchant, false);
          }
        });
      }
    });
  }

  // Category Apply Button
  const categoryApplyBtn = document.getElementById('category_apply_text');
  if (categoryApplyBtn) {
    categoryApplyBtn.addEventListener('click', function() {
      const loader = document.getElementById('categoryfilterloader');
      loader.classList.remove('hidden');

      const selectedCategories = Array.from(
        categoryList.querySelectorAll('input[type="checkbox"]:checked')
      ).map(checkbox => checkbox.value);

      applyForumFilters(selectedCategories, []);
    });
  }

  // Merchant Apply Button
  const merchantApplyBtn = document.getElementById('filter_apply_text');
  if (merchantApplyBtn) {
    merchantApplyBtn.addEventListener('click', function() {
      const loader = document.getElementById('filterloader');
      loader.classList.remove('hidden');

      const selectedMerchants = Array.from(
        merchantList.querySelectorAll('input[type="checkbox"]:checked')
      ).map(checkbox => checkbox.value);

      applyForumFilters([], selectedMerchants);
    });
  }

  // Clear Category Filter
  const clearCategoryBtn = document.getElementById('clear-category-filter');
  if (clearCategoryBtn) {
    clearCategoryBtn.addEventListener('click', function() {
      updateFilterCount('categories', 0);
      window.location.href = window.location.pathname + '?type=' + (new URLSearchParams(window.location.search).get('type') || 'new');
    });
  }

  // Clear Merchant Filter
  const clearMerchantBtn = document.getElementById('clear-merchant-filter');
  if (clearMerchantBtn) {
    clearMerchantBtn.addEventListener('click', function() {
      updateFilterCount('structure', 0);
      window.location.href = window.location.pathname + '?type=' + (new URLSearchParams(window.location.search).get('type') || 'new');
    });
  }

  // Initialize filter counts on page load based on URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const categoryFilters = urlParams.getAll('filters[group_ids][]');
  const merchantFilters = urlParams.getAll('filters[merchant_ids][]');

  updateFilterCount('categories', categoryFilters.length);
  updateFilterCount('structure', merchantFilters.length);
})

function renderCategory(category, forceCheck = false) {
  if (!categoryList) return;

  var truncatedName;
  if (window.innerWidth < 768) {
    truncatedName = category.name.length > 30 ? category.name.slice(0, 27) + "..." : category.name;
  } else {
    truncatedName = category.name.length > 20 ? category.name.slice(0, 17) + "..." : category.name;
  }

  categoryList.innerHTML += `
    <div class="search-item pb-4">
      <input type="checkbox" class="mr-2 text-primary focus:ring-0 add-category" id="category-${category.id}" value="${category.id}" data-category-name="${category.name}" ${forceCheck || isCategoryChecked(category.id) ? "checked" : ""}>
      <label for="category-${category.id}">${truncatedName}</label>
    </div>
  `;

  document.querySelectorAll(".add-category").forEach(function(cat) {
    cat.addEventListener("click", function() {
      addCategoryToDisplayList(this)
    })
  })
}

function renderMerchant(merchant, forceCheck = false) {
  if (!merchantList) return;

  var truncatedName;
  if (window.innerWidth < 768) {
    truncatedName = merchant.merchant_name.length > 30 ? merchant.merchant_name.slice(0, 27) + "..." : merchant.merchant_name;
  } else {
    truncatedName = merchant.merchant_name.length > 20 ? merchant.merchant_name.slice(0, 17) + "..." : merchant.merchant_name;
  }

  merchantList.innerHTML += `
    <div class="search-item pb-4">
      <input type="checkbox" class="mr-2 text-primary focus:ring-0 add-merchant" id="merchant-${merchant.permalink}" value="${merchant.permalink}" data-merchant-name="${merchant.merchant_name}" ${forceCheck || isMerchantChecked(merchant.permalink) ? "checked" : ""}>
      <label for="merchant-${merchant.permalink}">${truncatedName}</label>
    </div>
  `;

  document.querySelectorAll(".add-merchant").forEach(function(merchant) {
    merchant.addEventListener("click", function() {
      addMerchantToDisplayList(this)
    })
  })
}

let category_display_arr = [];
function addCategoryToDisplayList(category) {
  let categoryName = category.dataset.categoryName;
  let categoryId = category.value;
  if (category.checked) {
    if (!category_display_arr.includes(categoryName + ":" + categoryId)) {
      category_display_arr.push(categoryName + ":" + categoryId);
    }
  } else {
    let index = category_display_arr.indexOf(categoryName + ":" + categoryId);
    if (index > -1) {
      category_display_arr.splice(index, 1);
    }
  }

  renderCategoryChip(category_display_arr);
  updateFilterCount('categories', category_display_arr.length);
}

let merchant_display_arr = [];
function addMerchantToDisplayList(merchant) {
  let merchantName = merchant.dataset.merchantName;
  let merchantId = merchant.value;
  if (merchant.checked) {
    if (!merchant_display_arr.includes(merchantName + ":" + merchantId)) {
      merchant_display_arr.push(merchantName + ":" + merchantId);
    }
  } else {
    let index = merchant_display_arr.indexOf(merchantName + ":" + merchantId);
    if (index > -1) {
      merchant_display_arr.splice(index, 1);
    }
  }

  renderMerchantChip(merchant_display_arr);
  updateFilterCount('structure', merchant_display_arr.length);
}

function renderCategoryChip(categories) {
  let content = "";
  for (let category of categories) {
    let parts = category.split(":");
    let categoryName = parts[0];
    let categoryId = parts[1];
    content += `<div class="merchant-chip cursor-pointer mr-2 mb-1 py-1 px-2 rounded-full text-xs bg-secondary-icon-light dark:bg-secondary-icon-dark text-white dark:text-primary-text-light font-medium inline-block" data-category-id="${categoryId}">${categoryName}</div>`
  }

  const selectedCategoriesEl = document.getElementById("selected-categories");
  if (category_display_arr.length == 0) {
    selectedCategoriesEl.classList.remove("border-b", "border-light-border", "dark:border-dark-border");
  } else {
    selectedCategoriesEl.classList.add("border-b", "border-light-border", "dark:border-dark-border");
  }

  selectedCategoriesEl.innerHTML = content;

  document.querySelectorAll(".merchant-chip").forEach(function(chip) {
    chip.addEventListener("click", function() {
      removeCategoryChip(this);
    })
  })
}

function renderMerchantChip(merchants) {
  let content = "";
  for (let merchant of merchants) {
    let parts = merchant.split(":");
    let merchantName = parts[0];
    let merchantId = parts[1];
    content += `<div class="merchant-chip cursor-pointer mr-2 mb-1 py-1 px-2 rounded-full text-xs bg-secondary-icon-light dark:bg-secondary-icon-dark text-white dark:text-primary-text-light font-medium inline-block" data-merchant-id="${merchantId}">${merchantName}</div>`
  }

  const selectedMerchantsEl = document.getElementById("selected-merchants");
  if (merchant_display_arr.length == 0) {
    selectedMerchantsEl.classList.remove("border-b", "border-light-border", "dark:border-dark-border");
  } else {
    selectedMerchantsEl.classList.add("border-b", "border-light-border", "dark:border-dark-border");
  }

  selectedMerchantsEl.innerHTML = content;

  document.querySelectorAll(".merchant-chip").forEach(function(chip) {
    chip.addEventListener("click", function() {
      removeMerchantChip(this);
    })
  })
}

function removeCategoryChip(chip) {
  let content = chip.textContent;
  let id = chip.dataset.categoryId;
  let index = category_display_arr.findIndex(item => item === content + ":" + id);
  if (index > -1) {
    category_display_arr.splice(index, 1);
    document.getElementById(`category-${id}`).checked = false;
  }

  renderCategoryChip(category_display_arr);
  updateFilterCount('categories', category_display_arr.length);
}

function removeMerchantChip(chip) {
  let content = chip.textContent;
  let id = chip.dataset.merchantId;
  let index = merchant_display_arr.findIndex(item => item === content + ":" + id);
  if (index > -1) {
    merchant_display_arr.splice(index, 1);
    document.getElementById(`merchant-${id}`).checked = false;
  }

  renderMerchantChip(merchant_display_arr);
  updateFilterCount('structure', merchant_display_arr.length);
}

function isCategoryChecked(categoryId) {
  const checkbox = document.getElementById(`category-${categoryId}`);
  return checkbox && checkbox.checked;
}

function isMerchantChecked(merchantPermalink) {
  const checkbox = document.getElementById(`merchant-${merchantPermalink}`);
  return checkbox && checkbox.checked;
}

function applyForumFilters(groupIds, merchantIds) {
  window.forumPage = 2;
  window.forumFilterActive = true;

  const listView = document.querySelector('.list-view');
  if (listView) {
    listView.innerHTML = '<div class="flex h-[100px] w-full justify-center items-center"><div class="loader"></div></div>';
  }

  const type = new URLSearchParams(window.location.search).get('type') || 'new';
  const forumPath = window.location.pathname;

  const params = new URLSearchParams();
  params.set('type', type);
  groupIds.forEach(id => params.append('filters[group_ids][]', id));
  merchantIds.forEach(id => params.append('filters[merchant_ids][]', id));

  fetch(`${forumPath}?${params.toString()}`, {
    headers: {
      'Accept': 'text/javascript',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.text())
  .then(script => {
    eval(script);

    // Hide loading spinners
    const categoryLoader = document.getElementById('categoryfilterloader');
    const merchantLoader = document.getElementById('filterloader');
    if (categoryLoader) categoryLoader.classList.add('hidden');
    if (merchantLoader) merchantLoader.classList.add('hidden');

    // Close modals and unlock body scroll
    if (window.innerWidth < 768) {
      document.body.classList.remove("overflow-hidden");
    }
    const categoryFilter = document.getElementById('category-filter');
    const merchantFilter = document.getElementById('merchant-filter');
    if (categoryFilter) {
      closeFilterPanel(categoryFilter);
    }
    if (merchantFilter) {
      closeFilterPanel(merchantFilter);
    }
  })
  .catch(error => {
    console.error('Filter error:', error);

    // Hide loading spinners on error
    const categoryLoader = document.getElementById('categoryfilterloader');
    const merchantLoader = document.getElementById('filterloader');
    if (categoryLoader) categoryLoader.classList.add('hidden');
    if (merchantLoader) merchantLoader.classList.add('hidden');

    if (window.innerWidth < 768) {
      document.body.classList.remove("overflow-hidden");
    }

    if (listView) {
      listView.innerHTML = '<div class="text-center py-8 text-red-500">Error loading results</div>';
    }
  });
}
